import React from 'react';
import AnalyticsDashboard from '../components/analytics/AnalyticsDashboard';
import SeoTags from '@/components/shared/SeoTags';

/**
 * Page Analytics Dashboard
 * Point d'entrée pour le dashboard analytique vendeur
 */
const AnalyticsDashboardPage: React.FC = () => {
    return (
        <>
            <SeoTags
                title="Analytics | CashLive"
                description="Dashboard analytique complet pour suivre vos performances de vente en live-commerce"
            />
            <AnalyticsDashboard />
        </>
    );
};

export default AnalyticsDashboardPage;
